export default __webpack_public_path__ + "static/everywhere-lab-visit-3-f05150c9c66406e45255e793dc58cb52.jpg";